import { Component, Input, OnInit, Optional, ViewChild, } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { LANGUAGES } from '../user-input/language.labels';
import {
  emailRegexPattern, MAXIMUM_PASSWORD_LENGTH, MEDIUM_PASSWORD_PATTERN, MINIMUM_PASSWORD_LENGTH,
  passwordRegex, STRONG_PASSWORD_PATTERN,
  usernamePattern
} from '@irian-ro/constants';

@Component({
  selector: 'auth-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      deps: [NgForm, [new Optional(), NgModelGroup]],
      useFactory: (ngForm: NgForm, ngModelGroup: NgModelGroup): ControlContainer => ngModelGroup || ngForm,
    }
  ],
})
export class UserFormComponent implements OnInit {
  @Input() isUserAccountValid: boolean | undefined = undefined;
  @Input() showPasswords = false;
  @ViewChild('form') userForm: NgForm | undefined = undefined;
  @Input() phoneNumberRequired = false;
  @Input() phoneNumberDisabled = false;

  languages: SelectItem[] | undefined = undefined;
  phoneNumber: string | undefined = undefined;
  passwordConfirmation: string | null = null;
  isChecked: boolean | null = null;
  usernamePattern = usernamePattern;
  emailRegex = emailRegexPattern;
  mediumPasswordRegex = MEDIUM_PASSWORD_PATTERN
  strongPasswordRegex = STRONG_PASSWORD_PATTERN
  passwordRegex = passwordRegex
  minimumPasswordLength = MINIMUM_PASSWORD_LENGTH
  maximumPasswordLength = MAXIMUM_PASSWORD_LENGTH

  private _userData: any = {
    userPhoneDTO: {
      phoneNumber: null,
    },
  };

  get userData(): any {
    return this._userData;
  }

  @Input() set userData(value: any) {
    if (value) {
      this._userData = value;
    }
  }

  private _isNewUser: boolean = null;

  get isNewUser(): boolean {
    return this._isNewUser;
  }

  @Input()
  set isNewUser(value: boolean) {
    this._isNewUser = value;
  }

  _emailValue: string | null = null;

  get emailValue() {
    return this._emailValue;
  }

  @Input() set emailValue(value: string) {
    this._emailValue = value;
  }

  ngOnInit() {
    this.languages = LANGUAGES;
  }

  back() {
    console.log('go back');
  }

  isCheckboxRequired(): boolean {
    return this.isNewUser || (!this.isNewUser && this.userData.email !== this.emailValue);
  }

  protected readonly confirm = confirm;
}
